<p>{{to.label}} <strong>{{boolText}}</strong></p>